<template>
    <div v-if="false" class="promotion-bar w-full px-5 py-1 bg-kbred flex justify-center border-1 border-kbred mb-3">
        <div class="font-bold text-sm hidden lg:block text-white">
            Yeni yıl tatili sebebi ile ürün gönderimleri ve iade incelemeleri 5 Ocak Pazartesi günü başlayacaktır. Anlayışınız için teşekkür ederiz. İyi seneler 🎄
        </div>
        <div class="font-bold text-xs font-santralregular block lg:hidden text-center text-white">
            Yeni yıl tatili sebebi ile ürün gönderimleri ve iade incelemeleri 5 Ocak Pazartesi günü başlayacaktır. Anlayışınız için teşekkür ederiz. İyi seneler 🎄    
        </div>
    </div>
    
    <div class="">
        <header class="flex mx-auto flex-col max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl mt-8 md:mt-6 ts:mt-3 2xl:mt-8">
            <!-- logo -->
            <section class="flex flex-row justify-between relative">
                <div class="hidden ts:flex items-end justify-between">
                    <div class="block md:hidden cursor-pointer py-2" @mouseenter="menu = true" @mouseleave="menu = false">
                        <svg id="menu-right" class="mx-2 md:mx-0" xmlns="http://www.w3.org/2000/svg" width="32.216" height="22.55" viewBox="0 0 32.216 22.55">
                            <path id="Path_3735" data-name="Path 3735" d="M18,27.118a1.6,1.6,0,0,0,1.6,1.6H32.5a1.6,1.6,0,0,0,0-3.205H19.6a1.6,1.6,0,0,0-1.6,1.6Z" transform="translate(-18 -6.17)" fill="#ff6c37" />
                            <path id="Path_3736" data-name="Path 3736" d="M3,18.11a1.6,1.6,0,0,0,1.6,1.6h29.01a1.6,1.6,0,1,0,0-3.205H4.6a1.6,1.6,0,0,0-1.6,1.6Z" transform="translate(-2.999 -6.835)" fill="#ff6c37" />
                            <path id="Path_3737" data-name="Path 3737" d="M13.6,10.705a1.6,1.6,0,0,1,0-3.205H32.948a1.6,1.6,0,0,1,0,3.205H13.6Z" transform="translate(-11.999 -7.5)" fill="#ff6c37" />
                        </svg>
                    </div>

                    <div class="mr-4">
                        <h1 v-if="logoLink == '/'">
                            <Link :href="logoLink"><img class="w-11/12 max-h-[44px] mx-auto" :id="this.$inertia.page.url" :src="logoUrl" alt="" /></Link>
                        </h1>
                        <h1 v-else>
                            <a :href="logoLink"><img class="w-11/12 max-h-[44px] mx-auto" :id="this.$inertia.page.url" :src="logoUrl" alt="" /></a>
                        </h1>
                    </div>
                    <div class="hidden lg:block ml-12 mb-1">
                        <ul class="flex space-x-3 ts:space-x-8 text-xl leading-6.5 font-medium" v-if="!hideTopMenu">
                            <li class="p-0 m-0 text-lg text-left text-gray-900 box-border whitespace-no-wrap hover:text-checkoutgray">
                                <Link href="/nasil-calisir">Nasıl Çalışır?</Link>
                            </li>
                            <li class="p-0 m-0 text-lg text-left text-gray-900 box-border whitespace-no-wrap hover:text-checkoutgray">
                                <Link href="/hakkimizda">Hakkımızda</Link>
                            </li>

                            <li class="p-0 m-0 text-lg text-left text-gray-900 box-border whitespace-no-wrap hover:text-checkoutgray">
                                <Link href="/indirimli-urunler">İndirimli Ürünler</Link>
                            </li>
                            <!--                            <li class="p-0 m-0 text-lg text-left text-gray-900 box-border whitespace-no-wrap hover:text-checkoutgray">-->
                            <!--                                <Link href="/tags/1tl">1 TL</Link>-->
                            <!--                            </li>-->
                        </ul>
                    </div>
                </div>
                <BasketNotification
                    :show="
                        $page.props.flash.basketStatus?.type == 'added' ? true : false // setTimeout(() => { // basketNotificationShown = false; // }, 2000)
                    "
                />
                <div class="hidden ts:flex items-center">
                    <ul class="flex space-x-2">
                        <li class="text-sm md:text-base hidden md:block relative">
                            <Link href="/istek-listem" class="flex" v-if="auth.isUserLoggedIn">
                                Listem
                                <svg class="w-4 md:w-6 h-4 md:h-6 ml-1 stroke-[#231f20] overflow-visible" viewBox="0 0 30.669 28.092">
                                    <g id="heart" transform="translate(0 -1.511)" fill="none">
                                        <path
                                            d="M30.071,6.622A13.219,13.219,0,0,1,27.842,18.6,33.873,33.873,0,0,1,22.3,24.456c-1.823,1.7-5.9,5.054-6.983,5.147-.956-.182-2.028-1.263-2.787-1.82-4.264-3.24-8.853-7.181-11.18-11.49C-.6,12.156-.6,7.039,2.433,3.867a8.977,8.977,0,0,1,12.885.853A8.726,8.726,0,0,1,18.3,2.245a8.977,8.977,0,0,1,11.77,4.377Z"
                                            stroke="none"
                                        />
                                        <path
                                            d="M 22.02387619018555 4.511138916015625 C 21.19887924194336 4.511205673217773 20.36529541015625 4.668869018554688 19.54391098022461 4.980022430419922 C 18.81119155883789 5.373607635498047 18.20499801635742 5.888843536376953 17.69393539428711 6.551767349243164 L 15.37918663024902 9.55436897277832 L 12.98918724060059 6.611328125 C 11.93668746948242 5.315288543701172 10.24892616271973 4.541538238525391 8.474416732788086 4.541547775268555 C 7.442102432250977 4.541547775268555 5.927898406982422 4.800741195678711 4.52613639831543 6.020847320556641 C 3.402303695678711 7.246023178100586 3.083917617797852 8.801969528198242 3.016265869140625 9.90241813659668 C 2.916469573974609 11.52574920654297 3.276287078857422 13.31153869628906 4.030189514160156 14.94011974334717 C 4.942806243896484 16.60567092895508 6.383369445800781 18.40690231323242 8.313325881958008 20.29546737670898 C 9.916957855224609 21.86470985412598 11.82877540588379 23.48118019104004 14.32891082763672 25.38162803649902 C 14.57612991333008 25.56426811218262 14.81914901733398 25.76386070251465 15.05441665649414 25.95709800720215 C 15.1480712890625 26.03402137756348 15.26153087615967 26.12721252441406 15.37966251373291 26.22183418273926 C 16.63759994506836 25.36079597473145 18.77116775512695 23.64326858520508 20.25698661804199 22.26020812988281 L 20.30599594116211 22.2145881652832 L 20.35699653625488 22.17119789123535 C 22.4555778503418 20.38569831848145 24.10916709899902 18.6432991027832 25.41224670410156 16.84445953369141 L 25.43560600280762 16.81265830993652 C 27.5122241973877 14.02390670776367 28.17683982849121 10.72176933288574 27.27249336242676 7.72297477722168 C 26.7924976348877 6.758964538574219 26.07523345947266 5.959152221679688 25.18952560424805 5.402528762817383 C 24.26146697998047 4.819278717041016 23.16680717468262 4.511037826538086 22.02387619018555 4.511138916015625 M 22.02363014221191 1.511137008666992 C 25.47772216796875 1.510845184326172 28.58621597290039 3.41154670715332 30.07120704650879 6.62156867980957 L 30.07119750976562 6.62156867980957 C 31.46405601501465 10.92536735534668 30.29865646362305 15.30498790740967 27.84177589416504 18.60439872741699 C 26.22061729431152 20.84233856201172 24.28254699707031 22.77018737792969 22.30101776123047 24.45609855651855 C 20.47795677185059 26.15307807922363 16.39905548095703 29.51041793823242 15.31799697875977 29.60327911376953 C 14.36215591430664 29.42096900939941 13.28961753845215 28.33990859985352 12.53142738342285 27.78361892700195 C 8.267665863037109 24.54384803771973 3.678485870361328 20.60295867919922 1.351097106933594 16.29318809509277 C -0.5997524261474609 12.15636825561523 -0.6031627655029297 7.038997650146484 2.433006286621094 3.867378234863281 C 6.3704833984375 0.318359375 12.3065242767334 1.011802673339844 15.31799697875977 4.720129013061523 C 16.12644577026367 3.671438217163086 17.12146759033203 2.845949172973633 18.30135726928711 2.244508743286133 C 19.5473575592041 1.74708366394043 20.80727195739746 1.511240005493164 22.02363014221191 1.511137008666992 Z"
                                            stroke="none"
                                            fill="#231f20"
                                        />
                                    </g>
                                </svg>
                            </Link>
                            <span v-if="auth.isUserLoggedIn" class="font-santralextrabold text-xs lg:text-2xs 2xl:text-xs text-white bg-kbgreen rounded-full absolute w-4 h-4 font-normal -bottom-1 -right-1 flex justify-center items-center leading-none">{{ wishlist }}</span>
                        </li>
                        <li class="text-sm md:text-base relative">
                            <Link href="/sepetim" class="flex">
                                <span class="hidden md:block">Sepetim</span>
                                <span class="font-santralextrabold text-xs lg:text-2xs 2xl:text-xs text-white bg-kbgreen rounded-full absolute w-4 h-4 font-normal -bottom-1 -right-1 flex justify-center items-center leading-none">{{ cart }}</span>
                                <svg class="w-6 h-6 ml-1 stroke-[#231f20] overflow-visible" viewBox="0 0 30.324 31.234">
                                    <g id="Group_3491" data-name="Group 3491" transform="translate(1.51 1.5)">
                                        <path
                                            id="Path_2958"
                                            data-name="Path 2958"
                                            d="M212.736,218.3H199.28c-2.21,0-4.076-1.109-4.357-2.59l-2.53-13.314c-.337-1.774,1.709-3.345,4.357-3.345h18.515c2.648,0,4.695,1.571,4.358,3.345l-2.53,13.314C216.812,217.194,214.946,218.3,212.736,218.3Z"
                                            transform="translate(-192.356 -190.068)"
                                            fill="none"
                                            stroke="#231f20"
                                            stroke-miterlimit="10"
                                            stroke-width="3"
                                        />
                                        <path id="Path_2959" data-name="Path 2959" d="M202.477,192.194l5.167-7.892c.942-1.439,2.268-1.46,3.222-.052l5.381,7.944" transform="translate(-195.558 -183.208)" fill="none" stroke="#231f20" stroke-miterlimit="10" stroke-width="3" />
                                    </g>
                                </svg>
                            </Link>
                        </li>
                        <li class="text-sm md:text-base hidden md:block relative" v-if="auth.isUserLoggedIn">
                            <Link href="/profili-duzenle" class="flex">
                                Hesabım
                                <div class="font-santralextrabold text-xs leading-none text-kbgreen w-7 h-7 border-2 rounded-full border-black flex justify-center leading-none items-center ml-1">
                                    {{
                                        auth.user?.full_name
                                            .split(" ")
                                            .map((n) => n[0])
                                            .join("")
                                    }}
                                </div>
                            </Link>
                        </li>
                        <li class="text-sm md:text-base hidden md:block" v-if="!auth.isUserLoggedIn">
                            <Link :href="`/giris-yap`" class="flex">
                                Giriş/Üye Ol
                                <svg class="w-4 md:w-6 h-4 md:h-6 ml-1 stroke-[#231f20] overflow-visible" viewBox="0 0 34 34">
                                    <g id="Ellipse_138" data-name="Ellipse 138" fill="none" stroke="#231f20" stroke-width="3">
                                        <circle cx="17" cy="17" r="17" stroke="none" />
                                        <circle cx="17" cy="17" r="15.5" fill="none" />
                                    </g>
                                </svg>
                            </Link>
                        </li>
                    </ul>
                </div>
            </section>
            <NewMenu :auth="auth" :logoUrl="logoUrl" :wishlist="wishlist" :cart="cart"></NewMenu>
            <!-- search -->
            <section class="flex flex-row items-center mt-5 ts:mt-3">
                <div class="hidden lg:block pr-2" @mouseenter="menu = true" @mouseleave="menu = false">
                    <div class="bg-white rounded-xl flex cursor-pointer items-center shadow-buttonshadow px-5 md:px-8 py-3">
                        <img src="../../../images/svg/all-categories.svg" alt="" />
                        <span class="ml-1 whitespace-nowrap hover:text-kbgreen text-sm">TÜM KATEGORİLER</span>
                    </div>
                </div>
                <div class="group border w-full lg:w-10/12 rounded-xl shadow-searchshadow flex bg-white items-center relative">
                    <input type="text" class="peer placeholder-transparent w-full border-none rounded-xl p-3 px-5 md:px-8 text-base" v-model="searchForm.term" @keydown.enter="submitSearchForm" id="searchform" placeholder="Marka, ürün adı veya kategori yaz..." />
                    <label
                        for="searchform"
                        class="absolute left-4 top-0 transform transition-all peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-full -translate-y-full text-transparent text-xs peer-placeholder-shown:text-[11px] md:peer-placeholder-shown:text-base peer-placeholder-shown:text-placeholdergray peer-placeholder-shown:top-4 md:peer-placeholder-shown:top-3 peer-placeholder-shown:left-4 peer-focus:top-0 peer-focus:left-4 peer-focus:text-transparent peer-focus:text-xs"
                    >
                        Marka, ürün adı veya kategori yaz...
                    </label>
                    <div class="mr-3 md:mr-6 absolute top-3 right-0" @click="submitSearchForm">
                        <img src="../../../images/svg/search-green.svg" alt="" />
                    </div>
                </div>
            </section>
            <section class="relative">
                <Menu :active="menu" @menuchange="(val) => (menu = val)" :menuItems="menuItems"></Menu>
                <MobileMenu :active="menu" @menuchange="(val) => (menu = val)" :menuItems="menuItemsMobile" :auth="auth" :wishlist="wishlist"></MobileMenu>
            </section>
            <!-- categories & menu -->
            <section class="flex flex-col">
                <div class="overflow-x-scroll lg:overflow-x-visible mt-5">
                    <nav class="mx-auto">
                        <ul class="flex space-x-12 ts:space-x-6 2xl:space-x-12 text-sm pb-3 items-end">
                            <li>
                                <Link href="/kategoriler/ana-kucaklari">
                                    <div class="bg-white rounded-xl flex items-center">
                                        <img src="../../../images/category-icon/anakucagi.png" class="max-h-[35px]" />
                                        <span class="ml-1 whitespace-nowrap hover:text-kbgreen font-santralextrabold text-sm uppercase">Ana Kucağı</span>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link href="/kategoriler/ana-kucaklari/besik">
                                    <div class="bg-white rounded-xl flex items-center">
                                        <img src="../../../images/category-icon/besik.png" class="max-h-[35px]" />
                                        <span class="ml-1 whitespace-nowrap font-santralextrabold hover:text-kbgreen text-sm uppercase">Beşik</span>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link href="/kategoriler/ana-kucaklari/kanguru">
                                    <div class="bg-white rounded-xl flex items-center">
                                        <img src="../../../images/category-icon/kanguru.png" class="max-h-[35px]" />
                                        <span class="ml-1 whitespace-nowrap font-santralextrabold hover:text-kbgreen text-sm uppercase">Kanguru</span>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link href="/kategoriler/bebek-arabalari">
                                    <div class="bg-white rounded-xl flex items-center">
                                        <img src="../../../images/category-icon/bebekarabasi.png" class="max-h-[35px]" />
                                        <span class="ml-1 whitespace-nowrap font-santralextrabold hover:text-kbgreen text-sm uppercase">Bebek Arabası</span>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link href="/kategoriler/oyun-amp-oyuncak">
                                    <div class="bg-white rounded-xl flex items-center">
                                        <img src="../../../images/category-icon/oyun-oyuncak.png" class="max-h-[35px]" />
                                        <span class="ml-1 whitespace-nowrap font-santralextrabold hover:text-kbgreen text-sm uppercase">Oyun & Oyuncak</span>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <Link href="/kategoriler/oto-koltugu">
                                    <div class="bg-white rounded-xl flex items-center">
                                        <img src="../../../images/category-icon/otokoltugu.png" class="max-h-[35px]" />
                                        <span class="ml-1 whitespace-nowrap font-santralextrabold hover:text-kbgreen text-sm uppercase">Oto Koltuğu</span>
                                    </div>
                                </Link>
                            </li>
                            <li>
                                <a href="https://kiralabunu.com/" target="_blank">
                                    <div class="bg-white rounded-xl flex items-center">
                                        <img src="../../../images/cropped-ikon-192x192.png" class="max-h-[35px]" />
                                        <span class="ml-1 whitespace-nowrap font-santralextrabold hover:text-[#70d44b] text-sm uppercase">Kiralabunu</span>
                                    </div>
                                </a>
                            </li>
                            <!--                            <li class=" flex w-full items-center h-[30px] !block">-->
                            <!--                                <a class="w-[120px]" target="_blank" href="https://kiralamini.com/">-->
                            <!--                                    <img class="w-full max-w-[120px]"-->
                            <!--                                         src="../../../images/brands/kiralamini.png"-->
                            <!--                                         alt="">-->
                            <!--                                </a>-->
                            <!--                            </li>-->
                        </ul>
                    </nav>
                </div>
                <!-- for mobile, from Burak -->
            </section>
        </header>
        <slot />
        <footer>
            <section class="bg-[#4d7f71]" v-if="!auth.isUserLoggedIn">
                <div class="flex flex-col mx-auto max-w-kbmobile mts:max-w-tablet ts:max-w-ts 2xl:max-w-7xl">
                    <div class="text-white text-base md:text-2xl lg:text-2xl text-center mt-4 max-w-[242px] md:max-w-none mx-auto">Yenilikler ve indirimler için bültenimize abone ol.</div>
                    <form class="text-center mb-6 mt-6 flex justify-center">
                        <input type="email" v-model="subscribeForm.email" class="rounded-l-2lg mts:w-8/12 lg:w-4/12 leading-[70px] h-10 placeholder:text-sm md:placeholder:text-lg placeholder:text-placeholdergray py-6 md:px-6 text-base focus:outline-none" placeholder="E-Posta Adresin" required />
                        <button type="submit" @click="openSubscribeModal" class="bg-kbgreen text-base font-santralextrabold text-white px-8 py-3 rounded-r-2lg border-0 focus:outline-none whitespace-nowrap">Abone Ol</button>
                    </form>
                </div>
            </section>
            <section class="my-3 md:my-4 md:mt-4">
                <div class="flex flex-wrap lg:flex-nowrap mx-auto max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl lg:space-x-8">
                    <div class="w-6/12 md:w-6/12 lg:w-3/12 my-2 lg:my-0">
                        <h3 class="text-sm mts:text-base mt-3 text-[#4d7f71]">KİRALAMİNİ</h3>
                        <div class="flex flex-col mt-4 md:mt-8 leading-4">
                            <Link href="/" class="text-kbgray text-xs mts:text-sm mb-2">Anasayfa</Link>
                            <Link href="/hakkimizda" class="text-kbgray text-xs mts:text-sm mb-2">Hakkımızda</Link>
                            <Link href="/nasil-calisir" class="text-kbgray text-xs mts:text-sm mb-2">Nasıl Çalışır</Link>
                            <Link href="/sikca-sorulan-sorular" class="text-kbgray text-xs mts:text-sm mb-2">SSS</Link>
                            <Link href="/iletisim" class="text-kbgray text-xs mts:text-sm mb-2">İletişim</Link>
                            <Link href="/blog/" class="text-kbgray text-xs mts:text-sm mb-2">Blog</Link>
                        </div>
                    </div>
                    <div class="w-6/12 md:w-6/12 lg:w-3/12 my-2 lg:my-0 pl-2 md:pl-0">
                        <h3 class="text-sm mts:text-base mt-3 text-[#4d7f71]">BİLGİLENDİRME</h3>
                        <div class="flex flex-col mt-4 md:mt-8 leading-4">
                            <Link href="/uyelik-sozlesmesi" class="text-kbgray text-xs mts:text-sm mb-2">Üyelik Sözleşmesi</Link>
                            <Link href="/aydinlatma-metni" class="text-kbgray text-xs mts:text-sm mb-2">Aydınlatma Metni</Link>
                            <Link href="/cayma-fesih-ve-iade-kosullari" class="text-kbgray text-xs mts:text-sm mb-2"> Cayma, Fesih ve İade Koşulları</Link>
                            <Link href="/cerez-politikasi" class="text-kbgray text-xs mts:text-sm mb-2">Çerez (Cookie) Politikası</Link>
                            <!--                            <Link href="/kimlik-findeks-raporu" class="text-kbgray text-xs mts:text-sm mb-2">Kimlik ve Findeks Raporu</Link>-->
                            <Link href="/odeme-ve-teslimat" class="text-kbgray text-xs mts:text-sm mb-2">Ödeme ve Teslimat</Link>
                        </div>
                    </div>
                    <div class="w-full mts:w-6/12 lg:w-4/12 flex flex-col justify-center lg:justify-start lg:my-0">
                        <h3 class="text-sm mts:text-base mt-3 text-[#4d7f71]">İLETİŞİM</h3>
                        <div class="flex flex-col mt-4 lg:mt-8 leading-4">
                            <!--                            <p class="text-kbgray text-sm lg:text-sm">Hızlı destek için </p>-->
                            <!--                            <a href="tel:+908502551552" class="text-kbgreen text-3xl lg:text-3xl lg:mt-2 font-semibold">0850 255 1552</a>-->
                            <div class="flex" v-if="false">
                                <div class="text-kbgray text-xs mts:text-sm mb-2">Hızlı destek için</div>
                            </div>
                            <a href="https://wa.me/+905304001412" target="_blank" v-if="true">
                                <button class="bg-kbblue text-white text-xs lg:text-sm py-2 w-[240px] rounded-full mt-2 hover:opacity-[90%] whitespace-nowrap leading-tight font-santralextrabold">Whatsapp ile Bağlan</button>
                            </a>
                        </div>
                    </div>
                    <div class="w-full mts:w-6/12 lg:w-3/12 my-2 lg:my-0">
                        <h3 class="text-sm mts:text-base mt-3 text-[#4d7f71]">BİZİ TAKİP ET</h3>
                        <ul class="flex flex-row flex-wrap mts:flex-col mt-2 leading-4 space-y-2 mts:space-y-4">
                            <li class="flex w-1/2 mts:w-full items-center mt-2 mts:mt-4">
                                <a href="https://www.facebook.com/kiralamini" target="_blank" class="flex justify-center items-center bg-kb-light-grey rounded-full w-8 h-8">
                                    <svg width="7.385" height="14" viewBox="0 0 7.385 16" class="">
                                        <path id="" data-name="Facebook Icon" d="M6.981,2.83A4.442,4.442,0,0,0,5.69,2.617c-.525,0-1.654.362-1.654,1.064V5.362H6.719v2.83H4.035V16h-2.7V8.191H0V5.362H1.332V3.936C1.332,1.787,2.26,0,4.5,0A10.187,10.187,0,0,1,7.385.319Z" fill="#ff6c37" />
                                    </svg>
                                </a>
                                <a href="https://www.facebook.com/kiralamini" target="_blank">
                                    <span class="text-kbgray text-xs mts:text-sm ml-2">Facebook</span>
                                </a>
                            </li>
                            <li class="flex w-1/2 mts:w-full items-center pl-2 mts:pl-0">
                                <a href="https://www.instagram.com/kiralamini/" target="_blank" class="flex justify-center items-center bg-kb-light-grey rounded-full w-8 h-8">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="16" height="116">
                                        <path
                                            fill="#ff6c37"
                                            d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"
                                        />
                                    </svg>
                                </a>
                                <a href="https://www.instagram.com/kiralamini/" target="_blank">
                                    <span class="text-kbgray text-xs mts:text-sm ml-2">Instagram</span>
                                </a>
                            </li>
                            <li class="flex w-1/2 mts:w-full items-center">
                                <a href="https://www.linkedin.com/company/kiralabunu" target="_blank" class="flex justify-center items-center bg-kb-light-grey rounded-full w-8 h-8">
                                    <svg width="16" height="16" viewBox="0 0 16 16" class="scale-75">
                                        <path
                                            id="LinkedIn_Icon"
                                            data-name="LinkedIn Icon"
                                            d="M8.96,16H5.547q0-.937,0-1.872v-.006h0c0-3.042.008-6.189-.082-9.295h2.96L8.587,6.4H8.64a3.988,3.988,0,0,1,3.414-1.813,3.507,3.507,0,0,1,3.033,1.453A5.785,5.785,0,0,1,16,9.412V16H12.56V9.813c0-1.611-.583-2.427-1.733-2.427a1.909,1.909,0,0,0-1.76,1.307,2.518,2.518,0,0,0-.106.88V16ZM3.493,16H.08V4.826H3.493V16ZM1.76,3.467A1.69,1.69,0,0,1,0,1.733,1.716,1.716,0,0,1,1.813,0,1.7,1.7,0,0,1,3.6,1.733,1.711,1.711,0,0,1,1.76,3.467Z"
                                            fill="#ff6c37"
                                        />
                                    </svg>
                                </a>
                                <a href="https://www.linkedin.com/company/kiralabunu" target="_blank">
                                    <span class="text-kbgray text-xs mts:text-sm ml-2">Linkedin</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <div class="mt-6 block md:hidden max-w-kbmobile mx-auto md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl mb-7">
                <img src="../../../images/logos-white.png" alt="" />
            </div>
            <div class="bg-[#f5f5f5] pt-5 pb-3">
                <div class="max-w-tablet ts:max-w-ts 2xl:max-w-7xl mx-auto">
                    <div class="flex flex-col md:flex-row justify-between items-center">
                        <div class="flex">
                            <div class="text-sm text-kbgray">
                                <Link href="/kvkk"> Gizlilik Politikası</Link>
                            </div>
                        </div>
                        <div class="hidden lg:block">
                            <img src="../../../images/logocard.png" alt="" />
                        </div>
                        <div class="text-sm text-kbgray mx-1 mt-2">Kiralamini.com © 2025 Tüm Hakları Saklıdır</div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
    <TransitionRoot appear :show="isOpen" as="template">
        <Dialog as="div" @close="closeModal" class="relative z-10">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100" leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-25" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
                        <DialogPanel class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white px-5 py-5 z-70 text-left align-middle shadow-xl transition-all flex flex-col justify-center items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 62.051 62.051">
                                <g id="Group_4884" data-name="Group 4884" transform="translate(-73.036 -250.295)">
                                    <circle id="Ellipse_199" data-name="Ellipse 199" cx="31.025" cy="31.025" r="31.025" transform="translate(73.036 250.295)" fill="#ff6c37" />
                                    <path id="Path_3299" data-name="Path 3299" d="M351.649,476.232a3.45,3.45,0,0,1-2.761-1.381l-8.464-11.286a3.451,3.451,0,0,1,5.522-4.141l5.538,7.383,14.223-21.334a3.451,3.451,0,1,1,5.743,3.829l-16.928,25.393a3.453,3.453,0,0,1-2.776,1.536Z" transform="translate(-251.82 -178.764)" fill="#fff" />
                                </g>
                            </svg>
                            <DialogTitle>
                                <h2 class="text-base font-semibold text-center mb-2 mt-2">Teşekkürler</h2>
                            </DialogTitle>
                            <p class="text-xs font-kiralabunuthin ts:text-sm text-center">Yenilikler ve indirimler için aboneliğiniz oluşturuldu.</p>
                            <!--                            <div class="mt-4">-->
                            <!--                                <button-->
                            <!--                                    type="button"-->
                            <!--                                    class="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"-->
                            <!--                                    @click="closeModal"-->
                            <!--                                >-->
                            <!--                                    Got it, thanks!-->
                            <!--                                </button>-->
                            <!--                            </div>-->
                            <div class="absolute top-2 right-5 cursor-pointer p-2" @click="closeModal">x</div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import Menu from "@/Pages/Shared/Menu.vue";
import NewMenu from "@/Pages/Shared/NewMenu.vue";
import MobileMenu from "@/Pages/MobileMenu.vue";
import BasketNotification from "@/Pages/Shared/basketNotification.vue";
import basketNotification from "@/Pages/Shared/basketNotification.vue";
import { Dialog, DialogPanel, DialogTitle, Disclosure, DisclosureButton, DisclosurePanel, TransitionChild, TransitionRoot } from "@headlessui/vue";

export default {
    computed: {
        basketNotification() {
            return basketNotification;
        },
    },
    components: {
        BasketNotification,
        MobileMenu,
        Link,
        Menu,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        TransitionRoot,
        TransitionChild,
        Dialog,
        DialogPanel,
        DialogTitle,
        NewMenu,
    },
    data() {
        return {
            menu: false,
            userCart: null,
            userCartLength: 0,
            searchForm: this.$inertia.form({
                term: null,
            }),
            subscribeForm: this.$inertia.form({
                email: null,
            }),
            logoUrl: "/images/mini-logo.png",
            logoLink: "/",
            hideTopMenu: false,
            isOpen: false,
            hiddenbtn1: true,
            hiddenbtn2: true,
            hiddenbtn3: true,
            hiddenbtn4: true,
        };
    },
    props: {
        menuItems: Object,
        menuItemsMobile: Object,
        auth: Object,
        apiEP: String,
        wishlist: Number,
        cart: Number,
    },
    methods: {
        // toggleMenu() {
        //     this.menu = false;
        //     setTimeout(() => {
        //         //this.menu = false;
        //     }, 300);
        // },
        closeModal() {
            console.log(this.isOpen);
            this.isOpen = false;
        },
        openSubscribeModal() {
            if (this.subscribeForm.email == null || this.subscribeForm.email == "") return;

            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.subscribeForm.email)) {
                this.isOpen = true;
            }
        },
        submitSearchForm() {
            // Arama metni boşsa arama yapma
            if (this.searchForm.term == null || this.searchForm.term == "") return;
            this.searchForm.get(route("searchResults"));
        },
        newMessage(something) {
            console.log("newMessage", something);
            //this.$vueEventBus.$emit("message-in", something);
        },
    },
    mounted() {
        this.userCart = JSON.parse(localStorage.getItem("userCart")) || [];
        // this.userCartLength = this.userCart.length;
    },
    created() {
        this.$inertia.on("navigate", (event) => {
            this.logoUrl = "/images/mini-logo.png";
            if (event.detail.page.url == "/kurumsal") this.logoUrl = "/images/mini-logo.png";
            if (event.detail.page.url.endsWith("?teknosa")) {
                this.logoUrl = "https://img-teknosa-sap.mncdn.com/_ui/responsive/theme-teknosa/assets/images/logo.svg";
                this.hideTopMenu = true;
                this.logoLink = "https://teknosa.com";
            }

            dataLayer.push({
                pageView: event.detail.page.url,
                event: "virtualPageView",
            });
        });

        window.axios.defaults.headers.common["Authorization"] = `Bearer ${this.auth.token}`;

        if (this.auth.isUserLoggedIn && this.auth.user == null) {
            axios.get(`${this.apiEP}auth/user/cart/get-auth`).then((res) => {
                this.auth.user = res.data;
                window.localStorage.setItem("user", JSON.stringify(res.data));
            });
        } else if (this.auth.isUserLoggedIn && this.auth.user != null) {
            window.localStorage.setItem("user", JSON.stringify(this.auth.user));
        }
    },
    // setup() {
    //     const alert = computed(() => usePage().props.value.flash.alert);
    //     return { alert };
    // },
};
</script>

<style scoped></style>
